import React from 'react';
import LocationTemplate from './LocationTemplate';

const HalifaxPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Halifax"
      stateName="North Carolina"
      countyName="Halifax"
      zipCodes={["27839"]}
      latitude={36.3282}
      longitude={-77.5886}
      population={324}
      historicalFact="Site of the adoption of the Halifax Resolves (April 12, 1776), the first official call for independence from Britain by any American colony."
      nearbyTowns={[
        "Enfield, NC",
        "Scotland Neck, NC",
        "Weldon, NC",
        "Roanoke Rapids, NC",
        "Littleton, NC",
        "Whitakers, NC",
        "Hobgood, NC",
        "Hollister, NC"
      ]}
    />
  );
};

export default HalifaxPage;